import React from 'react';
import PropTypes from 'prop-types';
import { StyledIcon } from './components/IconStyles';

const Icon = ({ className, color, size, ariaLabel }) => {
  return (
    <StyledIcon
      className={className}
      color={color}
      size={size}
      aria-label={ariaLabel}
      aria-hidden={!ariaLabel}
      role={ariaLabel ? 'img' : undefined}
    />
  );
};

Icon.propTypes = {
  className: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  ariaLabel: PropTypes.string,
};

Icon.defaultProps = {
  color: undefined,
  size: 'md',
  ariaLabel: undefined,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Icon/Icon.jsx